<div class="bub">
  <div class="bub-head">
    <div>
      <h1 class="filter-title">{{ isSalesBrick ? 'Manage Sales Bricks' : 'Manage Bricks' }}</h1>
      <div class="text-muted" *ngIf="businessUnitName">{{businessUnitName}}</div>
    </div>
    <button type="button" class="close" title="Close" (click)="back()"><span aria-hidden="true">&times;</span></button>
  </div>

  <div class="bub-toolbar">
    <input type="text" class="form-control bub-search" placeholder="Search bricks" [(ngModel)]="search" name="search" />
    <span class="bub-action" [class.active]="panel=='add'" (click)="openPanel('add')"><i class="fa fa-plus-circle"></i> Add Bricks</span>
    <span class="bub-action" [class.active]="panel=='upload'" (click)="openPanel('upload')"><i class="fa fa-upload"></i> {{'app.provision' | translate}}</span>
    <span class="bub-action" *ngIf="selectedLinks.length > 0" [class.active]="panel=='closeMany'" (click)="startCloseMany()">
      <i class="fa fa-calendar-times-o"></i> Close selected ({{selectedLinks.length}})
    </span>
  </div>

  <div class="alert alert-danger bub-alert" *ngIf="hasNoCentre">
    This business unit has no centre brick. Mark one as centre: matrix expenses start from the centre bricks.
  </div>

  <div class="bub-panel" *ngIf="panel=='add'">
    <crm-add-business-unit-bricks [businessUnitId]="businessUnitId" [isSalesBrick]="isSalesBrick" [existingLinks]="links"
                                  (closeModalEvent)="onAddClosed($event)"></crm-add-business-unit-bricks>
  </div>

  <div class="bub-panel" [hidden]="panel!='upload'">
    <crm-provision-business-unit-bricks #provisionBusinessUnitBricks isSalesBrick="{{isSalesBrick}}"></crm-provision-business-unit-bricks>
    <div class="bub-panel-actions"><button class="btn btn-cancel" type="button" (click)="closeUpload()">Done</button></div>
  </div>

  <div class="bub-panel" *ngIf="panel=='close' && closingLink">
    <div class="row">
      <div class="col-sm-6">
        <b>Close {{closingLink.brickName}}</b>
        <div class="text-muted">Started {{closingLink.startDate | date:'dd/MM/yyyy'}}</div>
      </div>
      <div class="col-sm-6" [class.has-error]="closeSubmitted && !closeEndDate">
        <label class="control-label">{{'businessUnitBricks.EndDate' | translate}} *</label>
        <input type="date" class="form-control" name="closeEndDate" [(ngModel)]="closeEndDate" [min]="closingLink.startDate | date:'yyyy-MM-dd'" required />
        <div *ngIf="closeSubmitted && !closeEndDate" class="help-block">{{'app.RequiredField' | translate}}</div>
      </div>
    </div>
    <div class="bub-panel-actions">
      <button class="btn btn-cancel" type="button" (click)="panel='none'">{{'app.cancel' | translate}}</button>
      <button class="btn btn-save" type="button" [disabled]="saving" (click)="confirmClose()">Close link</button>
    </div>
  </div>

  <div class="bub-panel" *ngIf="panel=='closeMany'">
    <div class="row">
      <div class="col-sm-6">
        <b>Close {{selectedLinks.length}} brick link{{selectedLinks.length == 1 ? '' : 's'}}</b>
        <div class="text-muted">{{selectedLinks.length == openLinks.length ? 'All the open links shown.' : 'The ticked links.'}}
          The end date can't be before the latest start ({{selectedMinEndDate | date:'dd/MM/yyyy'}}).</div>
      </div>
      <div class="col-sm-6" [class.has-error]="closeSubmitted && !closeEndDate">
        <label class="control-label">{{'businessUnitBricks.EndDate' | translate}} *</label>
        <input type="date" class="form-control" name="closeManyEndDate" [(ngModel)]="closeEndDate" [min]="selectedMinEndDate" required />
        <div *ngIf="closeSubmitted && !closeEndDate" class="help-block">{{'app.RequiredField' | translate}}</div>
      </div>
    </div>
    <div class="bub-panel-actions">
      <button class="btn btn-cancel" type="button" (click)="panel='none'">{{'app.cancel' | translate}}</button>
      <button class="btn btn-save" type="button" [disabled]="saving || selectedLinks.length == 0" (click)="confirmCloseMany()">Close links</button>
    </div>
  </div>

  <div class="text-center bub-loading" *ngIf="displayMode==1">
    <i class="fa fa-spinner fa-spin"></i> {{'app.Loading' | translate}}
  </div>
  <div class="alert alert-danger" *ngIf="displayMode==3">{{'app.ServerError' | translate}}.</div>

  <div class="bub-table-wrap" *ngIf="displayMode==2">
    <table class="table table-bordered bub-table">
      <thead>
        <tr>
          <th class="bub-select"><input type="checkbox" title="Select all open links shown" [checked]="allOpenSelected"
                                        [disabled]="openLinks.length==0" (change)="toggleAllOpen($event.target.checked)" /></th>
          <th>Brick</th>
          <th>Level</th>
          <th *ngIf="!isSalesBrick">Is Centre</th>
          <th *ngIf="isSalesBrick">Percent</th>
          <th>Start</th>
          <th>End</th>
          <th>Created</th>
          <th>Modified</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="bub-group" (click)="showOpen=!showOpen">
          <td colspan="9"><i class="fa" [ngClass]="showOpen ? 'fa-caret-down' : 'fa-caret-right'"></i> Open ({{openLinks.length}})</td>
        </tr>
        <ng-container *ngIf="showOpen">
          <tr *ngFor="let link of openLinks" [class.bub-selected]="isSelected(link)">
            <td class="bub-select"><input type="checkbox" [checked]="isSelected(link)" (change)="toggleSelected(link, $event.target.checked)" /></td>
            <td>{{link.brickName}}</td>
            <td>{{link.brickLevelName}}</td>
            <td *ngIf="!isSalesBrick">
              <label class="switch">
                <input type="checkbox" [checked]="link.isCentre" (change)="toggleCentre(link, $event)">
                <span class="slider round"></span>
              </label>
            </td>
            <td *ngIf="isSalesBrick"><a href="javascript:;" class="bub-percent" [title]="link.onlyHolder ? 'Only holder of this brick in its line: gets all its sales' : 'Who shares this brick'" (click)="openShare(link)">{{link.onlyHolder && link.percent == 0 ? 100 : link.percent}}%<span class="text-muted small" *ngIf="link.onlyHolder"> (only holder)</span></a></td>
            <ng-container *ngIf="editingId != link.id">
              <td>{{link.startDate | date:'dd/MM/yyyy'}}</td>
              <td>{{link.endDate ? (link.endDate | date:'dd/MM/yyyy') : '—'}}</td>
            </ng-container>
            <ng-container *ngIf="editingId == link.id">
              <td><input type="date" class="form-control input-sm" [(ngModel)]="editStart" name="editStart" /></td>
              <td><input type="date" class="form-control input-sm" [(ngModel)]="editEnd" name="editEnd" [min]="editStart" /></td>
            </ng-container>
            <td class="bub-audit">{{link.createdByName}}<br />{{link.creationDate | date:'dd/MM/yyyy'}}</td>
            <td class="bub-audit">{{link.lastModifiedByName}}<br />{{link.lastModificationDate | date:'dd/MM/yyyy'}}</td>
            <td class="bub-actions">
              <ng-container *ngIf="editingId != link.id">
                <a href="javascript:;" title="Edit" (click)="startEdit(link)"><i class="fa fa-edit fa-lg"></i></a>
                <a href="javascript:;" title="Close" (click)="startClose(link)"><i class="fa fa-calendar-times-o fa-lg"></i></a>
              </ng-container>
              <ng-container *ngIf="editingId == link.id">
                <a href="javascript:;" title="Save" (click)="saveEdit(link)"><i class="fa fa-check fa-lg"></i></a>
                <a href="javascript:;" title="Cancel" (click)="cancelEdit()"><i class="fa fa-times fa-lg"></i></a>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="openLinks.length==0"><td colspan="9" class="text-muted">{{'app.NoDataFound' | translate}}</td></tr>
        </ng-container>

        <tr class="bub-group" (click)="showClosed=!showClosed">
          <td colspan="9"><i class="fa" [ngClass]="showClosed ? 'fa-caret-down' : 'fa-caret-right'"></i> Closed ({{closedLinks.length}})</td>
        </tr>
        <ng-container *ngIf="showClosed">
          <tr *ngFor="let link of closedLinks" class="bub-closed">
            <td></td>
            <td>{{link.brickName}}</td>
            <td>{{link.brickLevelName}}</td>
            <td *ngIf="!isSalesBrick">{{link.isCentre ? 'Yes' : 'No'}}</td>
            <td *ngIf="isSalesBrick"><a href="javascript:;" class="bub-percent" [title]="link.onlyHolder ? 'Only holder of this brick in its line: gets all its sales' : 'Who shares this brick'" (click)="openShare(link)">{{link.onlyHolder && link.percent == 0 ? 100 : link.percent}}%<span class="text-muted small" *ngIf="link.onlyHolder"> (only holder)</span></a></td>
            <td>{{link.startDate | date:'dd/MM/yyyy'}}</td>
            <td>{{link.endDate | date:'dd/MM/yyyy'}}</td>
            <td class="bub-audit">{{link.createdByName}}<br />{{link.creationDate | date:'dd/MM/yyyy'}}</td>
            <td class="bub-audit">{{link.lastModifiedByName}}<br />{{link.lastModificationDate | date:'dd/MM/yyyy'}}</td>
            <td></td>
          </tr>
          <tr *ngIf="closedLinks.length==0"><td colspan="9" class="text-muted">{{'app.NoDataFound' | translate}}</td></tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div class="bub-share-overlay" *ngIf="share || shareLoading" (click)="closeShare()">
  <div class="bub-share" (click)="$event.stopPropagation()">
    <div class="bub-share-head">
      <b>Percent details<span *ngIf="share"> — {{share.brickName}} · {{share.businessUnitName}}</span></b>
      <button type="button" class="close" (click)="closeShare()">&times;</button>
    </div>
    <div class="text-muted" *ngIf="shareLoading"><i class="fa fa-spinner fa-spin"></i> Loading…</div>
    <ng-container *ngIf="share">
      <div class="small text-muted">
        Period {{share.startDate | date:'dd/MM/yyyy'}} → {{share.endDate ? (share.endDate | date:'dd/MM/yyyy') : 'open'}}
        <span *ngIf="share.lineName"> · line {{share.lineName}}</span>
      </div>
      <table class="table table-bordered table-condensed bub-share-table">
        <thead><tr><th>Business unit</th><th>Percent</th><th>Start</th><th>End</th></tr></thead>
        <tbody>
          <tr *ngFor="let row of share.rows" [class.bub-share-own]="row.isThisLink" [class.bub-share-inactive]="!row.businessUnitActive">
            <td>{{row.businessUnitName}} <span class="label label-default" *ngIf="!row.businessUnitActive">inactive</span></td>
            <td>{{!share.shared && row.businessUnitActive && row.percent == 0 ? 100 : row.percent}}%</td>
            <td>{{row.startDate | date:'dd/MM/yyyy'}}</td>
            <td>{{row.endDate ? (row.endDate | date:'dd/MM/yyyy') : '—'}}</td>
          </tr>
        </tbody>
      </table>
      <div class="small">{{share.note}}</div>
    </ng-container>
  </div>
</div>
